<template>
	<!-- <font-awesome-icon icon="spinner" spin /> -->
  <div class="text-center">
	  <div class="loading m-auto" />
    Se il caricamento prende troppo tempo, 
    <a href=".">Ricarica la pagina</a>.
  </div>
</template>
<script>
export default{
	name: 'loading'
}
</script>
<style>
.loading{
  animation: loadingAnim 4s infinite;
  background: red;
  min-height: 32px;
  max-width: 32px;
  border-radius:  0 0 0 100%;
}


@keyframes loadingAnim{
  0%,10%,100%{
      border-radius: 100%;
  }
  25%{
    border-radius:  0 100% 0 0;
  }
  45%,55%{
      border-radius: 100% 0 0 0;
  }
  75%{
    border-radius:  0 0 0 100% ;
  }
}
</style>